import React, { useEffect, useState } from "react"
import {
  AppBar,
  Toolbar,
  Button,
  Menu,
  Box,
  Typography,
  Container,
} from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { getMegaMenus } from "../../features/megaMenuSlice"

const SubHeader = () => {
  const dispatch = useDispatch()
  const { list: megaMenu, loading } = useSelector((state) => state.megaMenu)

  const [anchorEl, setAnchorEl] = useState(null)
  const [activeKey, setActiveKey] = useState(null)

  useEffect(() => {
    dispatch(getMegaMenus())
  }, [dispatch])

  const handleOpen = (event, key) => {
    event.preventDefault()
    setAnchorEl(event.currentTarget)
    setActiveKey(key)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setActiveKey(null)
  }

  const activeMenu = megaMenu.find((m) => m.menu_key === activeKey)

  return (
    <AppBar
      position='static'
      elevation={1}
      sx={{
        bgcolor: "#d1e9e6",
        color: "#000",
      }}
    >
      <Container maxWidth={false}>
        <Toolbar
          disableGutters
          sx={{
            minHeight: 20,
            "@media (min-width:600px)": {
              minHeight: 44,
            },
            gap: 1,
            px: 1,
            display: "flex",
            flexWrap: "nowrap",
            justifyContent: "center",
            alignItems: "center",
            overflowX: "auto",
            overflowY: "hidden",

            // 🔥 smooth scrolling
            scrollBehavior: "smooth",

            // 🔥 hide scrollbar (optional)
            "&::-webkit-scrollbar": {
              display: "none",
            },
            msOverflowStyle: "none",
            scrollbarWidth: "none",
          }}
        >
          {/* ===== TOP LEVEL MENUS ===== */}
          {!loading &&
            megaMenu?.map((menu) => (
              <Button
                key={menu.menu_key}
                onMouseDown={(e) => handleOpen(e, menu.menu_key)}
                endIcon={<ExpandMoreIcon fontSize='small' />}
                sx={{
                  fontWeight: 600,
                  py: 0.5,
                  px: 1.5,
                  minHeight: "unset",
                  textTransform: "none",
                  whiteSpace: "nowrap", // ✅ prevents breaking text
                  flexShrink: 0,
                }}
              >
                {menu.title}
              </Button>
            ))}

          {/* ===== SINGLE MEGA MENU ===== */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            disableAutoFocusItem
            PaperProps={{
              sx: {
                width: "100vw",
                left: "0 !important",
                bgcolor: "#008080",
                color: "#fff",
                mt: 1,
                p: 2,
              },
            }}
          >
            <Box
              sx={{
                maxWidth: "lg",
                mx: "auto",
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: 2,
              }}
            >
              {activeMenu?.data?.sections?.map((section, i) => (
                <Box key={i}>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      mb: 0.5,
                      fontSize: "0.9rem",
                    }}
                  >
                    {section.heading}
                  </Typography>

                  {section.items?.map((item, idx) => (
                    <Typography
                      key={idx}
                      component={Link}
                      to={item.link}
                      onClick={handleClose}
                      sx={{
                        display: "block",
                        color: "#fff",
                        textDecoration: "none",
                        py: 0.25,
                        fontSize: "0.85rem",
                        lineHeight: 1.4,
                        "&:hover": {
                          textDecoration: "underline",
                        },
                      }}
                    >
                      {item.label}
                    </Typography>
                  ))}
                </Box>
              ))}
            </Box>

            {/* ===== FOOTER CTA ===== */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mt: 2,
                pt: 2,
                borderTop: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <Button
                variant='contained'
                component={Link}
                to='/services'
                sx={{
                  bgcolor: "white",
                  color: "#008080",
                  "&:hover": {
                    bgcolor: "rgba(255,255,255,0.9)",
                  },
                  px: 4,
                  py: 1,
                  fontWeight: "bold",
                  textTransform: "none",
                  borderRadius: "4px",
                }}
              >
                Explore All Industries
              </Button>
            </Box>
          </Menu>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default SubHeader
